export const searchTextRegex = /\s/g;
